module.exports = __webpack_public_path__ + "static/media/comic2011a.94ec1585.png";